<itl-wizard-page
  *ngIf="form"
  pageTitleTransPath="singleOrder.details.setPrescriptionStatus"
  [isSinglePage]="true"
  [pageIsValid]="form.valid"
  (doneClicked)="save()"
  (cancelClicked)="cancel()"
>
  <itl-info-box *ngFor="let error of form.errors | keys" [type]="warningType">
    {{ 'validation.errors.' + error | translate }}</itl-info-box
  >
  <itl-selection
    [title]="'singleOrder.prescriptionStatus' | translate"
    [(ngModel)]="prescriptionStatus"
    [values]="prescriptionStatusTypes"
    [formControl]="prescriptionStatusType"
    icon="alberta-status"
    [required]="true"
  ></itl-selection>
</itl-wizard-page>
